const validateEmployee = (values) => {
  const errors = {};
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const phoneRegex = /^[0-9]{11}$/; // تغيير هنا: تأكد من أن الرقم يتكون من 11 رقمًا

  // Required Fields
  
  // Name validation (Required)
  if (!values.name) {
    errors.name = "الاسم مطلوب / Name is required";
  }

  // Email validation (Required)
  if (!values.email) {
    errors.email = "البريد الإلكتروني مطلوب / Email is required";
  } else if (!emailRegex.test(values.email)) {
    errors.email = "البريد الإلكتروني غير صالح / Invalid email format";
  }

  // Phone validation (Required)
  if (!values.phone) {
    errors.phone = "رقم الهاتف مطلوب / Phone number is required";
  } else if (!/^[0-9]+$/.test(values.phone)) {
    errors.phone = "يجب أن يحتوي رقم الهاتف على أرقام فقط / Phone number must contain only digits";
  } else if (values.phone.length !== 11) {
    errors.phone = "يجب أن يتكون رقم الهاتف من 11 رقمًا / Phone number must be exactly 11 digits";
  }

  // Department validation (Required)
  if (!values.departmentId) {
    errors.departmentId = "القسم مطلوب / Department is required";
  }

  // Position validation (Required)
  if (!values.positionId) {
    errors.positionId = "المنصب مطلوب / Position is required";
  }

  // Date of Birth validation (Required)
  if (!values.dob) {
    errors.dob = "تاريخ الميلاد مطلوب / Date of birth is required";
  }

  // Join Date validation (Required)
  if (!values.joinDate) {
    errors.joinDate = "تاريخ الإلتحاق مطلوب / Join date is required";
  }

  // Badge Number validation (Required)
  if (!values.badgeNumber || values.badgeNumber.trim() === '') {
    errors.badgeNumber = "رقم الشارة مطلوب / Badge number is required";
  }

  // Fingerprint ID validation (Required)
  if (!values.fingerPrintId && values.fingerPrintId !== 0) {
    errors.fingerPrintId = "رقم البصمة مطلوب / Fingerprint ID is required";
  }

  // Optional Fields - only validate if a value is provided
  
  // Nature of Work validation (Required)
  if (values.natureOfWork === null || values.natureOfWork === undefined) {
    errors.natureOfWork = "طبيعة العمل مطلوبة / Nature of work is required";
  }

  // Contract Type validation (Optional)
  // if (values.contractType !== undefined && values.contractType !== null && values.contractType !== '') {
  //   // Add any specific validation rules if needed
  // }

  // Degree validation (Optional)
  if (values.degree !== undefined && values.degree !== null && values.degree !== '') {
    // Add any specific validation rules if needed
  }

  // Major validation (Optional)
  // if (values.major !== undefined && values.major !== null && values.major !== '') {
  //   // Add any specific validation rules if needed
  // }

  // Job Title validation (Optional)
  if (values.jobTitle !== undefined && values.jobTitle !== null && values.jobTitle !== '') {
    // Add any specific validation rules if needed
  }

  // Salary validation (Required)
  // if (!values.salary) {
  //   errors.salary = "الراتب مطلوب / Salary is required";
  // } else if (isNaN(values.salary) || Number(values.salary) <= 0) {
  //   errors.salary = "الراتب يجب أن يكون رقم موجب / Salary must be a positive number";
  // }

  return errors;
};

export default validateEmployee;
